import { Component } from '@angular/core';
import { MenuStateService } from '../../services/menu-state.service';

@Component({
  selector: 'app-menu-servicios',
  standalone: false,
  templateUrl: './menu-servicios.component.html',
  styleUrl: './menu-servicios.component.css'
})
export class MenuServiciosComponent {
  constructor(private menuStateService: MenuStateService) {
    }
  cerrarMenu(): void {
    this.menuStateService.toggleMenu(false);
  }
}
